









































import { Base } from "@/components/common/base";
import { PaginationModel, VAction, VHeaders } from "@/models/pagedlistmodel";
import { jobRequisitionService } from "@/shared";
import { Component } from "vue-property-decorator";

@Component({
    props: ['methodName', 'progress'],
    directives: {},
    computed: {
        methodtoCall: {
        get() {
            return this.$props.methodName;
        },
        },
    },
    components: {
        Grid: () => import("@/components/common/app.grid.vue"),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
})

export default class JobsListPage extends Base {
    public loading:boolean = false;
    public isApplicantData:boolean = false;
    public pagination = new PaginationModel('jobId');
    public jobActions:VAction[] = [];
    public applicantActions:any[] = [];
    public jobHeaders:VHeaders[] = [];
    public applicantHeaders:VHeaders[] = [];
    public jobItems: any[] = [];
    public applicantItems: any[] = [];
    public jobFilter:string = "";
    public jobFilters: any[] = [
        { value: "JobName", text: "Job Name" },
        { value: "OpenJobStatus", text: "Open" },
        { value: "PendingJobStatus", text: "Pending" },
        { value: "ClosedJobStatus", text: "Closed" },
        { value: "LocationName", text: "Location Name" },
        { value: "CandidateName", text: "Candidate Name" },
    ];

    public mounted(){
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'hierologyJobs');

        this.setHeaders();
        this.setActions();

        this.getJobs();
    }

    public setHeaders() {
        this.jobHeaders = [
            {
                text: "Job Name",
                align: "left",
                sortable: true,
                value: "jobName",
            },
            {
                text: "Job Status",
                align: "left",
                sortable: true,
                value: "jobStatus",
            },
            {
                text: "Location Name",
                align: "left",
                sortable: false,
                value: "locationName",
            },
            {
                text: "Job Visibility",
                align: "left",
                sortable: false,
                value: "jobVisibility",
            },
            {
                align: 'center',
                text: "Actions",
                isNotDataProp: true,
                sortable: false,
            },
        ];

        this.applicantHeaders = 
        [
            {
                text: "Candidate Id",
                align: "left",
                sortable: true,
                value: "candidateId",
            },
            {
                text: "Candidate Name",
                align: "left",
                sortable: false,
                value: "candidateName",
            },
            {
                text: 'Job Name',
                align: 'left',
                sortable: false,
                value : "jobName"
            },
            {
                text: "Candidate Email",
                align: "left",
                sortable: false,
                value: "candidateEmail",
            },
            {
                text: "Candidate Phone No",
                align: "left",
                sortable: false,
                value: "candidatePhoneNo",
            },
            {
                align: 'center',
                text: "Actions",
                isNotDataProp: true,
                sortable: false,
            }
        ];
    }

    public setActions() {
        this.jobActions = 
        [
            {
                type: "button",
                icon: "fas fa-users",
                title: "View Applicants",
                color: 'primary',
                visible: !this.isApplicantData,
                action: (model) => {
                    this.$router.push(
                    {   name :"recruitment.applicants", 
                        params:
                        {
                            jobId:model.jobId
                        }
                    });
                },
            },
            {
                type: "button",
                icon: "fas fa-eye",
                title: "View Details",
                color: 'primary',
                visible: this.isApplicantData,
                action: (model) => {
                    this.$router.push(
                    {   name :"recruitment.applicants.candidate", 
                        params:
                        {
                            jobId:model.jobId,
                            candidateId:model.candidateId
                        }
                    });
                },
            }
        ];

        
    }

    public async getJobs(){
        try{
            this.loading = true;
            if(this.jobFilter == "CandidateName") 
            {
                var response = await jobRequisitionService.getApplicantsByCandidateName(this.pagination, this.jobFilter);
                this.isApplicantData = true;
                this.applicantItems = response.results;
                this.pagination.totalItems = response.total;
            }
            else
            {
            this.isApplicantData = false;
            var response = await jobRequisitionService.getAllJobs(this.pagination, this.jobFilter);
            this.jobItems = response.results;
            this.pagination.totalItems = response.total;
            }
            this.setActions();
        }finally{
            this.loading = false;
        }
    }

    public updatePaging(paging: any) {
        this.pagination = paging;
        this.getJobs();
    }
}

